import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-scroller" }
const _hoisted_2 = { class: "modal-inner" }
const _hoisted_3 = ["innerHTML"]

import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {ref, watch} from 'vue';
import {useStore} from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'PlayerModal',
  setup(__props) {

const store = useStore();

const isOpen = ref(false);
watch(() => store.playVideo, (val, oldVal) => {
    if (val !== undefined && oldVal === undefined) {
        isOpen.value = true;
    }
});

const closeModal = () => {
    isOpen.value = false;
};

const onAfterClose = () => {
    store.setPlayVideo();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: isOpen.value,
    as: "template",
    onAfterLeave: onAfterClose
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        class: "modal",
        onClose: closeModal
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "modal-shade-enter-active",
            "enter-from": "modal-shade-enter-from",
            "enter-to": "modal-shade-enter-to",
            leave: "modal-shade-leave-active",
            "leave-from": "modal-shade-leave-from",
            "leave-to": "modal-shade-leave-to"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("div", { class: "modal-shade" }, null, -1 /* HOISTED */)
            ])),
            _: 1 /* STABLE */
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "modal-enter-active",
                "enter-from": "modal-enter-from",
                "enter-to": "modal-enter-to",
                leave: "modal-leave-active",
                "leave-from": "modal-leave-from",
                "leave-to": "modal-leave-to"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), { class: "modal-panel" }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        type: "button",
                        class: "modal-close",
                        onClick: closeModal
                      }, _cache[1] || (_cache[1] = [
                        _createElementVNode("svg", {
                          viewBox: "0 0 32 32",
                          width: "32",
                          height: "32"
                        }, [
                          _createElementVNode("use", { "xlink:href": "#icon-close" })
                        ], -1 /* HOISTED */)
                      ])),
                      _createElementVNode("div", {
                        class: "video-player",
                        innerHTML: _unref(store).playVideo.embed
                      }, null, 8 /* PROPS */, _hoisted_3)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}
}

})